<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12 justify-between">
        <div>
          <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
            Recebimento de Ferramenta - Requisição
          </p>
        </div>
        <div class="row col-md-2 col-xs-12 justify-end">
          <router-link
            :to="{
              name: 'ferramentaria-recebimento',
            }"
          >
            <div
              style="cursor: pointer"
              class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
            >
              <q-icon class="q-mr-sm icon-texto" name="west" color="brand-5" />
              <span class="texto-titulo">Voltar</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div
      class="q-mt-md q-gutter-sm row col-12 items-center text-brand-5 text-weight-bold"
    >
      <div>
        <div class="texto-titulo-input">Nº da Requisição</div>
        <q-input class="input" v-model="numeroVoucher" dense outlined />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-xs btn"
          icon="search"
          label="Pesquisar"
          color="primary"
          no-caps
          @click="listarItensVoucher()"
        />
      </div>
    </div>
    <div
      v-if="listaItemCriado.length > 0 || listaItemNaoCriado.length > 0"
      class="row col-12 q-mt-lg"
    >
      <CabecalhoNota
        :documentoNumeroDisable="true"
        :documentoNumero="numeroRequisicao"
        :tipo="false"
        :documentoSerie="false"
      />
    </div>
    <div class="q-mt-xl" v-if="listaItemNaoCriado.length > 0">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Itens Não Encontrados no Catálogo - Requisição #{{ numeroRequisicao }}
        </div>
        <div class="row col-md-3 col-xs-12 justify-end">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            v-model="filtro.naoEncontrado"
            class="col-md col-xs-7 input"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows="listaItemNaoCriado"
        :columns="columnsItemNaoCriado"
        flat
        dense
        color="primary"
        :filter="filtro.naoEncontrado"
        :rows-per-page-options="[0]"
        hide-bottom
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12"></div>
          <q-card class="container-grid-table col-12">
            <div class="row col-12 items-center q-pa-sm">
              <div class="col-9">
                <div class="row col-12">
                  <span><strong>Código: </strong>{{ props.row.codigo }}</span>
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Descrição: </strong>{{ props.row.descricao }}</span
                  >
                </div>
              </div>
            </div>
          </q-card>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row.codigo }}
            </q-td>
            <q-td>
              {{ props.row.descricao }}
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl" v-if="listarItemCriado">
      <div v-if="tab == 'itemReferencia'">
        <div class="row col-12 justify-between items-center q-mb-sm">
          <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
            Itens Encontrados no Catálogo - Requisição #{{ numeroRequisicao }}
          </div>
          <div class="row col-md-3 col-xs-12 justify-end">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              class="col-md col-xs-7 input"
              placeholder="Pesquisar"
              v-model="filtro.encontrado"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-tabs
          dense
          class="text-grey bg-grey-3 q-mb-sm"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
          inline-label
          v-model="tab"
        >
          <q-tab name="itemReferencia" label="Itens Encontrados" no-caps />
          <q-tab name="adicionarItem" label="Selecionar Ferramenta" no-caps />
        </q-tabs>
        <q-table
          :class="{ 'my-sticky-dynamic': !mobile }"
          :rows="listaItemCriado"
          :columns="columns"
          flat
          dense
          color="primary"
          :rows-per-page-options="[0]"
          :grid="mobile"
          :filter="filtro.encontrado"
          :hide-bottom="!listaItemCriado.length == 0"
          no-data-label="Nenhuma referencia encontrada."
        >
          <template v-slot:item="props">
            <div class="q-pa-xs row col-12"></div>
            <q-card class="container-grid-table col-12">
              <div class="row col-12 items-center q-pa-sm">
                <div class="col-6">
                  <div class="row col-12">
                    <span><strong>Código: </strong>{{ props.row.codigo }}</span>
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Descrição: </strong
                      >{{ props.row.descricao }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Patrimônio: </strong
                      >{{ props.row.patrimonio }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Grupo: </strong>{{ props.row.grupo.nome }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Subgrupo: </strong
                      >{{ props.row.subgrupo.nome }}</span
                    >
                  </div>
                </div>
                <div class="col">
                  <div class="row col-12 justify-end items-center">
                    <div class="q-mr-sm">
                      <div
                        style="
                          border: 1px solid #707070;
                          height: 60px;
                          width: 60px;
                          border-radius: 5px;
                        "
                      >
                        <q-img
                          v-if="props.row.url"
                          fit="contain"
                          height="100%"
                          width="95%"
                          :src="props.row.url"
                        />
                        <q-img
                          v-else
                          fit="contain"
                          height="100%"
                          width="95%"
                          src="../../../assets/semImagem.jpg"
                        />
                      </div>
                    </div>
                    <div class="q-ml-sm">
                      <q-btn
                        icon="article"
                        class="q-mr-sm"
                        color="blue"
                        round
                        flat
                        @click="
                          (rightDrawerOpen = true),
                            (editarItemSelecionado = { ...props.row })
                        "
                      />
                      <q-btn
                        round
                        size="10px"
                        icon="close"
                        :disable="props?.row?.itemReferencia"
                        color="red"
                        @click="removerItem(props.row.uuid)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
                <div style="display: inline" v-if="col.name === 'operacao'">
                  <q-icon
                    name="edit"
                    style="cursor: pointer"
                    size="17px"
                    @click="selectOperacao = !selectOperacao"
                  />
                </div>
                <div v-if="selectOperacao && col.name === 'operacao'">
                  <SelecaoOperacao
                    @enviarOperacao="receberOperacaoEditar"
                    @fecharSelecao="selectOperacao = false"
                  />
                </div>
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td class="coluna-selecionar">
                <q-btn
                  round
                  size="10px"
                  icon="close"
                  :disable="props?.row?.itemReferencia"
                  color="red"
                  @click="removerItem(props.row.uuid)"
                />
              </q-td>
              <q-td>
                {{ props.row.codigo }}
              </q-td>
              <q-td>
                {{ props.row.descricao }}
              </q-td>
              <q-td>
                <div
                  :style="{
                    'background-color':
                      ativosErrosIndicatorNew?.indexOf(props.row.patrimonio) !=
                      -1
                        ? 'red'
                        : '',
                  }"
                >
                  {{ props.row.patrimonio }}
                </div>
              </q-td>
              <q-td>
                {{ props.row.grupo.nome }}
              </q-td>
              <q-td>
                {{ props.row?.subgrupo?.nome }}
              </q-td>
              <q-td>
                <q-select
                  dense
                  style="width: 170px"
                  behavior="menu"
                  outlined
                  v-model="props.row.operacao"
                  option-label="nome"
                  option-value="transferenciaOperacaoUuid"
                  :options="options.operacaoOptions"
                  @filter="filterOperacao"
                />
              </q-td>
              <q-td>
                <q-btn
                  icon="article"
                  color="blue"
                  round
                  flat
                  @click="
                    (rightDrawerOpen = true),
                      (editarItemSelecionado = { ...props.row })
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
      <div v-else>
        <div class="row col-12 items-center q-mb-sm">
          <div
            class="row col-12 q-ml-md text-brand-5 text-weight-bold q-mb-md titulo-tabela"
          >
            Lista Ferramentas Catálogo
          </div>
          <div class="row col-12">
            <ComponenteFiltros
              :codigo="true"
              :classCodigo="'col-md col-xs-6'"
              :descricao="true"
              :classDescricao="'col-md col-xs-5'"
              :classGrupo="'col-md col-xs-6'"
              :subgrupo="true"
              :classSubgrupo="'col-md col-xs-5'"
              @enviarFiltro="receberFiltro"
            />
          </div>
        </div>
        <q-tabs
          dense
          class="text-grey bg-grey-3 q-mb-sm"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
          inline-label
          v-model="tab"
        >
          <q-tab name="itemReferencia" label="Itens Encontrados" no-caps />
          <q-tab name="adicionarItem" label="Selecionar Ferramenta" no-caps />
        </q-tabs>
        <q-linear-progress v-if="loading" indeterminate size="3px" />
        <q-table
          :class="{ 'my-sticky-dynamic': !mobile }"
          :rows="listaFerramentas"
          :columns="columnsItemCatalogo"
          flat
          dense
          color="primary"
          selection="multiple"
          :rows-per-page-options="[0]"
          row-key="uuid"
          :grid="mobile"
          v-model:selected="listaItemCriado"
          :hide-bottom="!listaFerramentas.length == 0"
          no-data-label="Nenhuma ferramenta encontrada."
        >
          <template v-slot:item="props">
            <div class="q-pa-xs row col-12"></div>
            <q-card class="container-grid-table col-12">
              <div class="row col-12 items-center q-pa-sm">
                <div class="col-8">
                  <div class="row col-12">
                    <span><strong>Código: </strong>{{ props.row.codigo }}</span>
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Descrição: </strong
                      >{{ props.row.descricao }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Grupo: </strong>{{ props.row.grupo.nome }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Subgrupo: </strong
                      >{{ props.row.subgrupo.nome }}</span
                    >
                  </div>
                </div>
                <div class="col">
                  <div class="row col-12 justify-end items-center">
                    <div class="q-mr-sm">
                      <div
                        style="
                          border: 1px solid #707070;
                          height: 60px;
                          width: 60px;
                          border-radius: 5px;
                        "
                      >
                        <q-img
                          v-if="props.row.url"
                          fit="contain"
                          height="100%"
                          width="95%"
                          :src="props.row.url"
                        />
                        <q-img
                          v-else
                          fit="contain"
                          height="100%"
                          width="95%"
                          src="../../../assets/semImagem.jpg"
                        />
                      </div>
                    </div>
                    <div class="q-ml-sm">
                      <q-btn
                        v-if="props.selected"
                        round
                        size="10px"
                        icon="close"
                        color="red"
                        :disable="verificarItemReferencia(props.row.uuid)"
                      />
                      <q-btn
                        v-else
                        round
                        size="10px"
                        icon="add"
                        color="secondary"
                        @click="props.selected = true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td class="coluna-selecionar">
                <q-btn
                  v-if="props.selected"
                  round
                  size="10px"
                  icon="close"
                  color="red"
                  :disable="verificarItemReferencia(props.row.uuid)"
                />
                <q-btn
                  v-else
                  round
                  size="10px"
                  icon="add"
                  color="secondary"
                  @click="props.selected = true"
                />
              </q-td>
              <q-td>
                {{ props.row.codigo }}
              </q-td>
              <q-td>
                {{ props.row.descricao }}
              </q-td>
              <q-td>
                {{ props.row.grupo.nome }}
              </q-td>
              <q-td>
                {{ props.row.subgrupo.nome }}
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-center q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            :size="mobile ? 'md' : 'sm'"
          />
        </div>
      </div>
    </div>
    <div v-if="listarItemCriado" class="row col-12 q-mt-lg q-gutter-sm">
      <div>
        <q-btn
          v-if="tab == 'itemReferencia'"
          label="Criar"
          color="positive"
          no-caps
          icon="done"
          class="btn"
          @click="enviarRecebimento()"
        />
        <q-btn
          v-else
          label="Salvar"
          color="positive"
          no-caps
          icon="save"
          class="btn"
          @click="tab = 'itemReferencia'"
        />
      </div>
      <div>
        <q-btn
          label="Cancelar"
          color="negative"
          no-caps
          icon="cancel"
          class="btn"
          @click="resetar()"
        />
      </div>
    </div>
    <ModalAdicionarAtivoItem
      :itemCatalogo="editarItemSelecionado"
      :rightDrawerOpen="rightDrawerOpen"
      :multiplicar="false"
      :fornecedor="false"
      :esconderLocada="true"
      @fecharModal="rightDrawerOpen = false"
      @salvarAlteracoes="salvarAlteracoesItemSelecionado"
    />
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { ref, computed, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import ModalAdicionarAtivoItem from "../components/ModalAdicionarAtivoItem.vue";
import SelecaoOperacao from "../components/SelecaoOperacao.vue";
import CabecalhoNota from "../components/CabecalhoNota.vue";

const columnsItemNaoCriado = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "codigo",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    field: "descricao",
  },
];
const columns = [
  {
    name: "remover",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "codigo",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    field: "descricao",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "operacao",
    label: "Operação",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    align: "left",
  },
];
const columnsItemCatalogo = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
];
export default {
  components: {
    ComponenteFiltros,
    ModalAdicionarAtivoItem,
    SelecaoOperacao,
    CabecalhoNota,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const listaItensVoucher = ref([]);
    const numeroVoucher = ref("");
    const catalogoUuid = salvarCatalogoUuid();
    const atributosFerramentas = ref([]);
    let rightDrawerOpen = ref(false);
    let disable = ref(false);
    let mobile = ref(false);
    const disableAtributo = ref(false);
    const ferramentaUuid = ref("");
    const dadoAtributo = ref([{ chave: "", valor: "" }]);
    const subTab = ref("associar");
    const checklistCriar = ref({ nome: "", descricao: "" });
    const listaItemCriado = ref([]);
    const listaItemNaoCriado = ref([]);
    const listaFerramentas = ref([]);
    const ativosErrosIndicatorNew = ref([]);
    const numeroRequisicao = ref("");
    const options = ref({ operacaoOptions: [] });
    const editarItemSelecionado = ref({});
    const filtros = ref({});
    const loading = ref(false);
    const selectOperacao = ref(false);
    const filtro = ref({ naoEncontrado: "", encontrado: "" });
    let listarItemCriado = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const tab = ref("itemReferencia");

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarItensVoucher = async () => {
      if (numeroVoucher.value === "") {
        quasar.notify({
          message: "Digite o numero da requisição.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      numeroRequisicao.value = "";
      quasar.loading.show({
        message: `Procurando referências de ferramentas na requisição #${numeroVoucher.value}`,
        spinnerColor: "brand-1",
      });
      listaItemCriado.value = [];
      listaItemNaoCriado.value = [];
      try {
        const response = await store.dispatch(
          "requisicao/buscarDetalheRequisicao",
          { reqId: numeroVoucher.value }
        );
        numeroRequisicao.value = response.data.model.id;
        verificarCodigoItem(response.data.model.products);
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: `Nenhuma requisição encontrada com o numero ${numeroVoucher.value}`,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        quasar.loading.hide();
      }
    };

    const verificarCodigoItem = (array) => {
      if (array.length == 0) {
        quasar.notify({
          message: `Nenhum item associado a requisição ${numeroRequisicao.value}`,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        quasar.loading.hide();
        return;
      }
      array.forEach((item) => {
        buscarItemCatalogo(item);
      });
    };

    const buscarItemCatalogo = async (objetoItem) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            perPage: 100,
            page: 1,
            codigo: objetoItem?.code,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            comAcessorios: "sim",
            comAtributos: "sim",
            comCheckLists: "sim",
          }
        );
        let listaItemCatalogo = [];
        listaItemCatalogo = response.listaFerramentas;
        let indexItem = listaItemCatalogo.findIndex(
          (item) => item.codigo == objetoItem.code
        );
        if (indexItem == -1) {
          adicionarItemNaoCriado(objetoItem);
        } else {
          adicionarItemCriado(
            listaItemCatalogo[indexItem],
            objetoItem?.pivot?.amount,
            objetoItem?.contracts[0].pivot?.price
          );
        }
        listarItemCriado.value = true;
        quasar.loading.hide();
      } catch (error) {
        console.log(error);
      }
    };

    const enviarRecebimento = async () => {
      if (
        store.state.ferramentaria?.cabecalhoNota?.fornecedor?.parceiroId ==
        undefined
      ) {
        quasar.notify({
          message: "O campo fornecedor não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let itens = [];
      if (listaItemCriado.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos um item.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let validoOperacao = false;
      validoOperacao = verificarOperacaoEnvio();
      if (!validoOperacao) {
        quasar.notify({
          message: "Preencha o campo operação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      listaItemCriado.value.forEach((item) => {
        itens.push({
          operacaoUuid: item?.operacao?.transferenciaOperacaoUuid,
          novoAtivo: {
            catalogoItemUuid: item?.uuid,
            codigo: item?.codigo,
            documentoTipo: "voucher",
            documentoSerie: store.state.ferramentaria?.cabecalhoNota?.serie,
            documentoNumero: numeroRequisicao.value.toString(),
            fornecedorId:
              store.state.ferramentaria?.cabecalhoNota?.fornecedor?.parceiroId,
            documentoEmissao:
              store.state.ferramentaria?.cabecalhoNota?.dataEmissao
                ?.split("/")
                .reverse()
                .join("-"),
            tempoPermanencia: parseFloat(item?.tempoPermanencia),
            depositoLocalUuid: item?.deposito?.depositoLocalUuid,
            responsavelId: item?.responsavelId,
            atributos:
              item?.atributos.length > 0
                ? montarAtributoArray(item?.atributos)
                : undefined,
            acessorios:
              item?.acessorios.length > 0
                ? montarAcessorioArray(item?.acessorios)
                : undefined,
            checkLists:
              item?.checkLists.length > 0
                ? montarChecklistArray(item?.checkLists)
                : undefined,
            patrimonio: item?.patrimonio,
            origem: item?.origem?.value,
            preco: parseFloat(item?.valor),
            valorLocacao: parseFloat(item?.valorLocacao),
          },
        });
      });
      let valido = verificarCampoPreenchido(itens);
      if (!valido) {
        return;
      }
      try {
        disable.value = true;
        ativosErrosIndicatorNew.value = [];
        await store.dispatch("ferramentaria/criarTransferenciaManual", {
          unidadeId: store.state.org.unidadeData.id,
          etapa: "transferencia_manual_voucher",
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          documentoTipo: "voucher",
          documentoSerie: store.state.ferramentaria?.cabecalhoNota?.serie,
          documentoNumero: numeroRequisicao.value.toString(),
          documentoEmissao:
            store.state.ferramentaria?.cabecalhoNota?.dataEmissao
              ?.split("/")
              .reverse()
              .join("-"),
          ativos: itens,
        });
        quasar.notify({
          message: "Itens enviados com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetar();
        disable.value = false;
        router.push({ name: "ferramentaria-recebimento" });
      } catch (error) {
        ativosErrosIndicatorNew.value.push(
          error.response?.data?.erros?.dados?.patrimonio
        );

        if (
          error?.response?.data?.erro?.mensagem !=
          "Solicitacao incorreta, verifique 'detalhes' para mais informacao"
        ) {
          quasar.notify({
            message: error.response.data.erros.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error?.response?.data?.erros?.erro) {
          quasar.notify({
            message: error?.response?.data?.erros?.erro,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data?.erro?.detalhes?.ativos) {
          for (const key in error.response?.data?.erro?.detalhes?.ativos) {
            if (
              Object.hasOwnProperty.call(
                error.response?.data?.erro?.detalhes?.ativos,
                key
              )
            ) {
              const element = error.response?.data?.erro?.detalhes?.ativos[key];
              quasar.notify({
                message: `${key.charAt(0).toUpperCase()}${key.substring(
                  1
                )} ${element}`,
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          }
        }
        disable.value = false;
      }
    };

    const verificarOperacaoEnvio = () => {
      const valido = listaItemCriado.value.every(
        (item) =>
          item?.operacao?.transferenciaOperacaoUuid != "" &&
          item?.operacao?.transferenciaOperacaoUuid != undefined
      );
      return valido;
    };

    const adicionarItemNaoCriado = (objetoItem) => {
      listaItemNaoCriado.value.push({
        codigo: objetoItem?.code,
        descricao: objetoItem.name,
      });
    };

    const montarChecklistArray = (arrayChecklist) => {
      let array = [];
      arrayChecklist.forEach((checklist) => {
        array.push({
          checkListUuid: checklist.checkListUuid,
        });
      });
      return array;
    };

    const montarAcessorioArray = (arrayAcessorio) => {
      let array = [];
      arrayAcessorio.forEach((acessorio) => {
        if (acessorio.uuid) {
          array.push({
            acessorioUuid: acessorio.uuid,
          });
        } else {
          array.push({
            nome: acessorio.nome,
          });
        }
      });
      return array;
    };

    const montarAtributoArray = (arrayAtributo) => {
      let array = [];
      arrayAtributo.forEach((atributo) => {
        array.push({
          chave: atributo.chave,
          valor: atributo.valor,
        });
      });
      return array;
    };

    const verificarCampoPreenchido = (array) => {
      let campoPreenchido = true;
      for (let i = 0; i < array.length; i++) {
        const linha = array[i];
        if (
          linha.novoAtivo?.depositoLocalUuid == undefined ||
          linha.novoAtivo?.depositoLocalUuid == ""
        ) {
          quasar.notify({
            message: `Preencha o campo local de deposito do item ${linha.novoAtivo?.codigo}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          campoPreenchido = false;
        }
        if (
          linha.novoAtivo?.tempoPermanencia === undefined ||
          linha.novoAtivo?.tempoPermanencia === ""
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo tempo de permanencia do item ${linha.novoAtivo?.codigo} `,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          linha.novoAtivo?.origem == "" ||
          linha.novoAtivo?.origem == undefined
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo origem do item ${linha.novoAtivo?.codigo}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          linha.novoAtivo?.origem != "consumo" &&
          (linha.novoAtivo?.patrimonio == "" ||
            linha.novoAtivo?.patrimonio == undefined)
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo patrimonio do item ${linha.novoAtivo?.codigo}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (!campoPreenchido) {
          break;
        }
      }
      return campoPreenchido;
    };

    const adicionarItemCriado = (objetoItem, quantidade, valor) => {
      for (let i = 1; i <= parseInt(quantidade); i++) {
        listaItemCriado.value.push({
          valorUnicoItem: gerarUuid(),
          itemReferencia: true,
          tempoPermanencia: objetoItem?.tempoPermanencia,
          uuid: objetoItem?.uuid,
          codigo: objetoItem?.codigo,
          descricao: objetoItem?.descricao,
          grupo: objetoItem?.grupo,
          subgrupo: objetoItem?.subgrupo,
          valor: valor,
          atributos: objetoItem?.atributos,
          checkLists: objetoItem?.checkLists,
          acessorios: objetoItem?.acessorios,
        });
      }
    };

    const gerarUuid = () => {
      let d = new Date().getTime();

      if (
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
      ) {
        d += performance.now();
      }

      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    };

    const listarItensCatalogo = async (page = 1, perPage = 10) => {
      if (catalogoUuid.catalogoUuid.value === null) {
        listaFerramentas.value = [];
        return;
      }
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            perPage: perPage,
            page: page,
            codigo: filtros.value?.codigo,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
            nome: filtros.value?.descricao,
            comAcessorios: "sim",
            comAtributos: "sim",
            comCheckLists: "sim",
            nomeGrupo: filtros.value?.grupo?.nome,
            nomeSubgrupo: filtros.value?.grupo?.nome
              ? filtros.value?.subgrupo?.nome
              : "",
          }
        );
        listaFerramentas.value = response.listaFerramentas;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    };

    const salvarAlteracoesItemSelecionado = (value) => {
      if (value.itemReferencia) {
        let index = listaItemCriado.value.findIndex(
          (item) => item.valorUnicoItem == value.valorUnicoItem
        );
        listaItemCriado.value.splice(index, 1, value);
        return;
      }
      let index = listaItemCriado.value.findIndex(
        (item) => item.uuid == value.uuid
      );
      listaItemCriado.value.splice(index, 1, value);
    };

    const removerItem = (uuid) => {
      listaItemCriado.value = listaItemCriado.value.filter(
        (item) => item.uuid != uuid
      );
    };

    const verificarItemReferencia = (uuid) => {
      let index = listaItemCriado.value.findIndex((item) => item.uuid == uuid);
      if (listaItemCriado.value[index].itemReferencia) {
        return true;
      } else {
        return false;
      }
    };

    const resetar = () => {
      listaFerramentas.value = [];
      listaItemCriado.value = [];
      listaItemNaoCriado.value = [];
      listarItemCriado.value = false;
      numeroVoucher.value = "";
    };

    const listarOperacao = async (val) => {
      try {
        const response = await store.dispatch("ferramentaria/listarOperacao", {
          catalogoUuid: store.state.ferramentaria.catalogoUuid,
          nome: val,
        });
        options.value.operacaoOptions = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const receberOperacaoEditar = (value) => {
      preencherValoresColunaSelecionados(value, "operacao");
    };

    const preencherValoresColunaSelecionados = (valor, coluna) => {
      listaItemCriado.value.forEach((ativo) => {
        ativo[coluna] = valor;
      });
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarItensCatalogo();
    };

    watch(
      () => tab.value,
      () => {
        if (tab.value == "adicionarItem") {
          listarItensCatalogo();
        }
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarItensCatalogo(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    return {
      columns,
      listarItensVoucher,
      listaItensVoucher,
      columnsItemCatalogo,
      numeroVoucher,
      router,
      atributosFerramentas,
      rightDrawerOpen,
      removerItem,
      enviarRecebimento,
      receberFiltro,
      salvarAlteracoesItemSelecionado,
      disable,
      verificarCampoPreenchido,
      mobile,
      tab,
      subTab,
      receberOperacaoEditar,
      listarOperacao,
      verificarOperacaoEnvio,
      options,
      dadoAtributo,
      preencherValoresColunaSelecionados,
      ativosErrosIndicatorNew,
      checklistCriar,
      verificarItemReferencia,
      disableAtributo,
      ferramentaUuid,
      editarItemSelecionado,
      gerarUuid,
      verificarCodigoItem,
      buscarItemCatalogo,
      catalogoUuid,
      listaItemCriado,
      filtro,
      filterOperacao(val, update) {
        listarOperacao(val);
        setTimeout(() => {
          update();
        }, 300);
      },
      resetar,
      listaItemNaoCriado,
      montarAcessorioArray,
      montarAtributoArray,
      montarChecklistArray,
      selectOperacao,
      columnsItemNaoCriado,
      numeroRequisicao,
      listaFerramentas,
      listarItemCriado,
      listarItensCatalogo,
      loading,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
tbody tr .coluna-atributo {
  width: 250px !important;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.input-atributo {
  margin-top: 25px;
}
.icon {
  margin-top: 26px;
}
.texto-titulo {
  font-size: 20px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-texto {
  font-size: 25px;
  margin-right: 1px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo-modal {
  font-size: 16px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-texto {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    font-size: 12px;
    margin-bottom: 2px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .container-btn {
    justify-content: center;
  }
  .btn-acoes {
    font-size: 13px;
  }
}
</style>
